<template>
  <svg width="18" height="18" viewBox="0 0 18 18" class="custom-icon" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5603 15.4397L13.7528 11.6321C14.5391 10.4461 14.9999 9.02646 14.9999 7.50002C14.9999 3.36443 11.6355 0 7.49994 0C3.36457 0 0 3.36461 0 7.50002C0 11.6356 3.36439 15 7.49994 15C9.02618 15 10.446 14.5393 11.632 13.753L15.4395 17.5605C16.0247 18.1465 16.9753 18.1465 17.5606 17.5605C18.1465 16.9751 18.1465 16.025 17.5604 15.4396L17.5603 15.4397ZM2.2502 7.49993C2.2502 4.60492 4.60527 2.24992 7.50016 2.24992C10.395 2.24992 12.7501 4.60501 12.7501 7.49993C12.7501 10.3949 10.395 12.75 7.50016 12.75C4.60501 12.75 2.2502 10.3949 2.2502 7.49993Z"
    />
  </svg>
</template>
